import api from './login';

export { api };
